const getMarketFromQueryParam = (): undefined | string =>
  (window && new URLSearchParams(window.location.search).get('market')?.toLowerCase()) ?? undefined;

const getMarketFromPathname = (): undefined | string =>
  window.location.pathname
    ?.split('/')
    ?.filter?.((v) => !!v)?.[0]
    ?.toLowerCase?.();

const getMarket = (): 'USA' | 'CAN' => {
  const value = getMarketFromQueryParam() ?? getMarketFromPathname();

  if (value?.startsWith('ca')) return 'CAN';

  return 'USA';
};

export default getMarket;
